import { DEFAULT_EQUIP } from "../constants";
import { callAI, getTextFromResponse } from "./api";

export function cleanAiJson(txt) {
  if (!txt) return "";
  let s = String(txt).trim();
  s = s.replace(/```json|```/gi, "").trim();
  const first = s.indexOf("{");
  const last = s.lastIndexOf("}");
  if (first !== -1 && last !== -1 && last > first) {
    s = s.slice(first, last + 1);
  }
  s = s.replace(/,\s*(\]|\})/g, "$1");
  return s;
}

export async function fixAiJsonViaProxy(raw) {
  const data = await callAI({
    _action: "session_gen",
    model: "claude-sonnet-4-20250514",
    maxTokens: 400,
    temperature: 0.1,
    system: "Tu es un correcteur JSON. Corrige le texte fourni pour qu'il devienne un JSON strictement valide. Renvoie UNIQUEMENT le JSON corrigé, sans commentaire ni markdown.",
    messages: [
      {
        role: "user",
        content: `Texte à corriger:\n${raw}`,
      },
    ],
  });
  const txt = getTextFromResponse(data);
  const cleaned = cleanAiJson(txt);
  return JSON.parse(cleaned);
}

const EQUIPMENT_LABELS = {
  bodyweight: "Poids du corps",
  dumbbells: "Haltères",
  kettlebells: "Kettlebells",
  barbell: "Barre + rack",
  bands: "Élastiques",
  machines: "Machines guidées",
  trx: "TRX / sangles",
  cardioTapis: "Tapis de course",
  cardioVelo: "Vélo / bike",
  cardioRameur: "Rameur",
  cardioSkiErg: "SkiErg",
  cardioStep: "Step / escaliers",
};

export function buildEquipmentSummary(equipObj) {
  const eq = { ...DEFAULT_EQUIP, ...(equipObj || {}) };
  const available = [];
  const unavailable = [];

  Object.entries(EQUIPMENT_LABELS).forEach(([k, label]) => {
    if (eq[k]) available.push(label);
    else unavailable.push(label);
  });

  const customRaw = Array.isArray(eq.custom) ? eq.custom : [];
  const customNorm = customRaw.map((it) => (typeof it === "string" ? { label: it, enabled: true } : it));
  const customOn = customNorm.filter((it) => it.enabled).map((it) => it.label);
  const customOff = customNorm.filter((it) => !it.enabled).map((it) => it.label);

  if (customOn.length) available.push(...customOn);
  if (customOff.length) unavailable.push(...customOff);

  return {
    available: available.length ? available.join(", ") : "poids du corps uniquement",
    unavailable: unavailable.length ? unavailable.join(", ") : "aucun indique",
  };
}

export function buildFallbackExercises() {
  return [
    { name: "Squat gobelet", sets: 3, reps: 10, weight: 0, rest: 90, mode: "reps", duration: 0, youtubeQuery: "squat gobelet technique", notes: "Bloc bas du corps" },
    { name: "Pompes inclinées", sets: 3, reps: 12, weight: 0, rest: 75, mode: "reps", duration: 0, youtubeQuery: "pompes inclinees banc", notes: "Bloc haut du corps" },
    { name: "Rowing haltères unilatéral", sets: 3, reps: 12, weight: 0, rest: 75, mode: "reps", duration: 0, youtubeQuery: "row unilateral haltere", notes: "Dos / tirage" },
    { name: "Fente marchée", sets: 3, reps: 10, weight: 0, rest: 90, mode: "reps", duration: 0, youtubeQuery: "fente marchee technique", notes: "Bas du corps" },
    { name: "Soulevé de terre jambes tendues", sets: 3, reps: 10, weight: 0, rest: 90, mode: "reps", duration: 0, youtubeQuery: "souleve de terre jambes tendues", notes: "Ischios / chaîne postérieure" },
    { name: "Gainage planche", sets: 3, reps: 0, weight: 0, rest: 45, mode: "chrono", duration: 35, youtubeQuery: "gainage planche", notes: "Core / stabilité" },
    { name: "Farmer walk", sets: 3, reps: 0, weight: 0, rest: 60, mode: "chrono", duration: 30, youtubeQuery: "farmer walk", notes: "Grip + core" },
    { name: "Respiration / mobilité douce", sets: 1, reps: 0, weight: 0, rest: 0, mode: "chrono", duration: 120, youtubeQuery: "routine mobilite full body", notes: "Retour au calme actif" },
  ];
}
